/** Stable decorative bar heights (0–1). Not a real audio waveform. */
export const DECORATIVE_WAVEFORM_HEIGHTS: readonly number[] = [
  0.22, 0.38, 0.55, 0.72, 0.44, 0.9, 0.62, 0.34, 0.78, 0.5, 0.86, 0.28, 0.58, 0.8, 0.42, 0.66, 0.52,
  0.94, 0.36, 0.6, 0.3, 0.76, 0.48, 0.68, 0.4, 0.84, 0.56, 0.32, 0.7, 0.46, 0.88, 0.54, 0.26, 0.64,
  0.74, 0.5,
];

export function formatMediaClock(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return "0:00";
  }
  const total = Math.floor(seconds);
  const minutes = Math.floor(total / 60);
  const rest = total % 60;
  return `${minutes}:${rest.toString().padStart(2, "0")}`;
}

export function mediaProgressRatio(current: number, duration: number): number {
  if (!Number.isFinite(current) || !Number.isFinite(duration) || duration <= 0) {
    return 0;
  }
  return Math.min(1, Math.max(0, current / duration));
}
